import {MobileActionsInterface} from "@interfaces/components/mobile-actions.interface";

export enum NavigationBackButtonTypeEnum {
  CATALOG = 'CATALOG',
  BACK = 'BACK',
  ORDER_CREATION = 'ORDER_CREATION',
  MOBILE_MAP = 'MOBILE_MAP',
  CHAPTER_SINGLE = 'CHAPTER_SINGLE'
}

export enum MobileNavigationBackButtonTypeEnum {
  TWO_PART_HEADER_WITH_SEARCH_AND_ADDRESS_SELECTION = 'TWO_PART_HEADER_WITH_SEARCH_AND_ADDRESS_SELECTION',
  SEARCH_WITH_BONUS = 'SEARCH_WITH_BONUS',
  BACK_WITH_BONUS = 'BACK_WITH_BONUS',
  ONLY_BACK = 'ONLY_BACK',
  BACK_WITH_ADDRESS_SELECTION_AND_SEARCH = 'BACK_WITH_ADDRESS_SELECTION_AND_SEARCH',
  ONLY_BONUS = 'ONLY_BONUS',
  BACK_WITH_ADDRESS_SELECTION_AND_FAVORITE = 'BACK_WITH_ADDRESS_SELECTION_AND_FAVORITE',
  BACK_WITH_ADDRESS_SELECTION = 'BACK_WITH_ADDRESS_SELECTION'
}

export const MobileNavigationBackButtonActionsBasedEnum: {
  [key in MobileNavigationBackButtonTypeEnum]: MobileActionsInterface
} = {
  [MobileNavigationBackButtonTypeEnum.TWO_PART_HEADER_WITH_SEARCH_AND_ADDRESS_SELECTION]: {
    showRightSearch: false,
    showLeftSearch: true,
    showBonus: true,
    showBack: false,
    showAddress: false,
  },

  [MobileNavigationBackButtonTypeEnum.SEARCH_WITH_BONUS]: {
    showRightSearch: false,
    showLeftSearch: true,
    showBonus: true,
    showBack: false,
    showAddress: false,
  },

  [MobileNavigationBackButtonTypeEnum.BACK_WITH_BONUS]: {
    showRightSearch: false,
    showLeftSearch: false,
    showBonus: true,
    showBack: true,
    showAddress: false,
  },

  [MobileNavigationBackButtonTypeEnum.ONLY_BACK]: {
    showRightSearch: false,
    showLeftSearch: false,
    showBonus: false,
    showBack: true,
    showAddress: false,
  },

  [MobileNavigationBackButtonTypeEnum.BACK_WITH_ADDRESS_SELECTION_AND_SEARCH]: {
    showRightSearch: true,
    showLeftSearch: false,
    showBonus: false,
    showBack: true,
    showAddress: true,
  },

  [MobileNavigationBackButtonTypeEnum.ONLY_BONUS]: {
    showRightSearch: false,
    showLeftSearch: false,
    showBonus: true,
    showBack: false,
    showAddress: false,
  },

  [MobileNavigationBackButtonTypeEnum.BACK_WITH_ADDRESS_SELECTION_AND_FAVORITE]: {
    showRightSearch: false,
    showLeftSearch: false,
    showBonus: false,
    showBack: true,
    showAddress: true,
    showFavorite: true
  },

  [MobileNavigationBackButtonTypeEnum.BACK_WITH_ADDRESS_SELECTION]: {
    showRightSearch: false,
    showLeftSearch: false,
    showBonus: false,
    showBack: true,
    showAddress: true,
  },
};
